import { render, staticRenderFns } from "./EmployeeDocumentCreateOrUpdate.vue?vue&type=template&id=1b7bbd96&"
import script from "./EmployeeDocumentCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocumentCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports